import Vue from "vue";
import axios from "axios";
import AppFlickityModal from "@components/AppFlickityModal.vue";
import { docReady, qsa, onClick } from "@libs/helpers";

docReady( () => {

	const el = document.getElementById('vue-flickity-modal');
  let state;

	if ( !el ) {
		return;
	}

	const data = {
		slides: false,
		visible: false
	};

  const initialState = {
    visible: false,
    flickityModalHistory: true,
    slides: false
  };

  const dismissUrl = window.location.href;

  if ( history.state && !history.state.flickityModalHistory ) {
    history.replaceState( initialState, null , window.location.href );
    // console.log(initialState);
  }

	const v = new Vue({
		el,
		data,
		render: h => h( AppFlickityModal, {
			props: {
				visible:data.visible,
				slides:data.slides,
			},

			on: {
				dismiss() {
					data.visible = false;
          history.pushState({ flickityModalHistory: true, visible: false, slides: false }, null, window.location.pathname);
				}
			}

		} ),
	});

	window.vueData = data;

  window.onpopstate = ({ state }) => {
    if(!state) return;

    const { flickityModalHistory, visible, slides } = state;

    if ( !flickityModalHistory ) {
      return;
    }

    data.visible = visible;
    data.slides = slides;
  }

	onClick('[data-trigger-flickity-modal]', function(e) {
		// 'this' is the button that was clicked,
		e.preventDefault();

		const target = this.getAttribute('data-trigger-flickity-modal');

		if ( !target ) {
			console.error(`No target set`);
			return;
		}

		const slides = APP.flickitySlides[ target ];

		if ( !slides ) {
			console.error(`Slides not found for ${target}`);
			return;
		}

		data.slides = slides;
		data.visible = true;

    if(this.id) {
      state = { flickityModalHistory: true, visible: true, slides: slides };
      window.history.pushState(state, null, `#${this.id}`);
    }

  });

  if(window.location.hash) {

    let triggerEl = document.querySelector(window.location.hash);

    if (triggerEl) {

      if (triggerEl.dataset.triggerFlickityModal) {

        let target = triggerEl.getAttribute('data-trigger-flickity-modal');
        const slides = APP.flickitySlides[target];

        if (!slides) {
          console.error(`Slides not found for ${target}`);
          return;
        }

        data.slides = slides;
        data.visible = true;
      }
    }
  }

	// const target = 'blockId';
	// const slides = APP.flickitySlides[ target ];
	// data.slides = slides;
	// data.visible = true;

});

